export const SECTION_CONFIG = [
  { background: "linear-gradient(270deg, #4c4d4e 50%, #4c4d4ecc)", color: "white" },
  {
    background: "linear-gradient(270deg, #376672cc, #376672 47.25%, #376672, #376672 47.25%)",
    color: "white",
    left: 0,
    right: "auto",
  },
  { background: "linear-gradient(270deg, #f1f3f4, #f1f3f4cc 47.25%)", color: "black" },
  {
    background: "linear-gradient(90deg, #ede9e4 50%, #ede9e4cc)",
    color: "black",
    left: 0,
    right: "auto",
  },
  { background: "linear-gradient(90deg, #000c, #000 52.75%)", color: "white" },
  { background: "linear-gradient(90deg, #4c4d4e 50%, #4c4d4ecc)", color: "white", left: 0, right: "auto" },
];
